import { Controller } from "@hotwired/stimulus"

// Modern Swiper imports (v7/v8/v9+)
// If using importmaps/Rails 7, this might just be: import Swiper from 'swiper'
import Swiper from 'swiper/bundle'; 
import 'swiper/css/bundle'; 

export default class extends Controller {
  // Define the pagination element as a target
  static targets = [ "pagination" ]

  connect() {
    // Initialize Swiper on 'this.element' (the main container)
    this.swiper = new Swiper(this.element, {
      slidesPerView: 2,
      centeredSlides: false,
      loop: false,
      speed: 900,
      spaceBetween: 20,
      breakpoints: {
        // Mobile
        768: {
          slidesPerView: 1,
          spaceBetween: 0,
          initialSlide: 0,
          centeredSlides: false
        }
      },
      pagination: {
        // Use the target instead of a unique ID string
        el: this.paginationTarget, 
        clickable: true,
      }
    });
  }

  // Good practice: Clean up when the element is removed (e.g., Turbo navigation)
  disconnect() {
    if (this.swiper) {
      this.swiper.destroy();
    }
  }
}
